import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmusersetmealproject/cecUnmUserSetMealProject/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmusersetmealproject/cecUnmUserSetMealProject/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmusersetmealproject/cecUnmUserSetMealProject/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmusersetmealproject/cecUnmUserSetMealProject/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmusersetmealproject/cecUnmUserSetMealProject/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmusersetmealproject/cecUnmUserSetMealProject/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmusersetmealproject/cecUnmUserSetMealProject/import',
      method: 'post',
      data: data
    })
  }
}
